// extracted by mini-css-extract-plugin
export default {"wrapper":"HistoryModal_wrapper__rZATw","contentBox":"HistoryModal_contentBox__hU6lq","AnnotationText":"HistoryModal_AnnotationText__1rAF4"};